const OrderListIcon = ({ isActive }) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1264_20711"
        style={{
          maskType: 'alpha',
        }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="17"
        height="17"
      >
        <rect x="0.5" y="0.973877" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1264_20711)">
        <path
          d="M2.5 15.6405V14.6405H4.16667V14.1405H3.16667V13.1405H4.16667V12.6405H2.5V11.6405H4.5C4.68889 11.6405 4.84722 11.7044 4.975 11.8322C5.10278 11.96 5.16667 12.1183 5.16667 12.3072V12.9739C5.16667 13.1628 5.10278 13.3211 4.975 13.4489C4.84722 13.5767 4.68889 13.6405 4.5 13.6405C4.68889 13.6405 4.84722 13.7044 4.975 13.8322C5.10278 13.96 5.16667 14.1183 5.16667 14.3072V14.9739C5.16667 15.1628 5.10278 15.3211 4.975 15.4489C4.84722 15.5767 4.68889 15.6405 4.5 15.6405H2.5ZM2.5 10.9739V9.14055C2.5 8.95166 2.56389 8.79332 2.69167 8.66555C2.81944 8.53777 2.97778 8.47388 3.16667 8.47388H4.16667V7.97388H2.5V6.97388H4.5C4.68889 6.97388 4.84722 7.03777 4.975 7.16555C5.10278 7.29332 5.16667 7.45166 5.16667 7.64055V8.80721C5.16667 8.9961 5.10278 9.15444 4.975 9.28221C4.84722 9.40999 4.68889 9.47388 4.5 9.47388H3.5V9.97388H5.16667V10.9739H2.5ZM3.5 6.30721V3.30721H2.5V2.30721H4.5V6.30721H3.5ZM6.5 13.6405V12.3072H14.5V13.6405H6.5ZM6.5 9.64055V8.30721H14.5V9.64055H6.5ZM6.5 5.64055V4.30721H14.5V5.64055H6.5Z"
          fill={isActive ? '#00cf83' : '#89D3B8'}
        />
      </g>
    </svg>
  )
}

export default OrderListIcon
